export default __webpack_public_path__ + "static/loading-242f0dd0d31496ff452f5e6b5a37c5c0.gif";